let _scrollPos = 0;

function setScrollPos(scrollPos: number): void {
    _scrollPos = scrollPos;
}

function getScrollPos(): number {
    return _scrollPos;
}

export {
    setScrollPos,
    getScrollPos
};
